<template>
  <div>
    <el-card>
      <div style="display: flex">
        <div style="width: 50%">
          <el-row>
            <el-col v-if="isShow">
              <el-button :disabled="editFlag" size="small" type="warning" @click="stprEdit"
                >编辑</el-button
              >
            </el-col>
            <el-col v-else>
              <el-button size="small" type="primary" @click="submit()">保存</el-button>
              <el-button size="small" @click="closeEdit">取消</el-button>
            </el-col>
          </el-row>
          <el-form ref="laseRef" :disabled="isShow" :model="prop" :rules="laseRules" label-width="120px" size="small">
            <el-row>
              <el-col :md="12">
                <el-form-item label="产品激光用量：" prop="rfid_lase_phr">
                  <el-input :value="prop.rfid_lase_phr" maxlength="9" show-word-limit @input="lasePhrChange">
                    <template slot="append">片</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="贴布激光用量：" prop="rfid_patch_lase">
                  <el-input :value="prop.rfid_patch_lase" maxlength="9" show-word-limit @input="lasePatchChange">
                    <template slot="append">片</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="填卡人：" prop="card_user_id">
                  <el-select v-model="prop.card_user_id" filterable placeholder="请选择">
                    <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form :disabled="isShow" label="right" label-width="100px">
            <el-row>
              <el-form-item label="制作人：" size="small">
                <el-select
                  v-model="prop.stff_id"
                  :disabled="!['徐礼明', '盖新', 'Admin'].includes($cookies.get('userInfo').stff_name)"
                  filterable
                  placeholder="请选择"
                  @change="
                    val => {
                      const find = processList.find(item => item.value === val).o;
                      prop.user_id = find.user_id;
                      prop.stff_name = find.stff_name;
                    }
                  "
                >
                  <el-option v-for="item in processList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="岗位：" size="small">
                <el-input :value="prop.user_jobs" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="难度系数：" size="small">
                <el-input :value="prop.price" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item>
                <SubTable2 ref="subTable" :isShow="isShow" :stffList="processList" />
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { post } from '@api/request';
import { spocAPI } from '@api/modules/spoc';
import helper from '@assets/js/helper';
import SubTable2 from '@/views/DevelopManagement/SmplManage/TabChild/Componet/TabPanel/subTable/subTable2';

export default {
  components: { SubTable2 },
  data() {
    return {
      laseForm: {},
      isShow: true,
      laseRules: {
        rfid_lase_phr: [
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' },
          { required: true, message: '请输入激光用量', trigger: 'blur' }
        ],
        rfid_patch_lase: [{ pattern: /^[0-9]*$/, message: '只能输入零和正整数!' }]
      }
    };
  },
  props: {
    prop: Object,
    rfid_perm_status: Number,
    rfid_Info: Object,
    editFlag: Boolean,
    mainIsShow: Boolean,
    originalLase: Object,
    stffList: Array,
    processList: Array
  },
  methods: {
    stprEdit() {
      this.$emit('num');
      this.isShow = false;
    },
    submit() {
      this.$refs['laseRef'].validate(valid => {
        if (valid) {
          this.$confirm('此操作将保存修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(res => {
              let editBody = {};
              editBody = JSON.parse(JSON.stringify(this.prop));
              editBody.list = this.$refs.subTable.tableData.filter(x => (x.rfid_lase_id ? true : !x.rfid_lase_id && !x.destroy_flag));
              if (!editBody.rfid_id) {
                editBody.rfid_id = this.rfid_Info.rfid_id;
                editBody.user_id = this.rfid_Info.user_id;
                editBody.stff_name = this.rfid_Info.stff_name;
                editBody.stff_id = this.rfid_Info.stff_id;
              }
              post(spocAPI.edit_lase, editBody)
                .then(res => {
                  if (res.data.code == 0) {
                    this.$message.success(res.data.msg);
                    this.$emit('copyLase', this.prop);
                  } else {
                    this.$message.error(res.data.msg);
                  }

                  this.$emit('del');
                })
                .catch(res => {
                  this.$message.error(res.data.msg);
                });

              this.isShow = true;
            })
            .catch(res => {});
        }
      });
    },
    closeEdit() {
      this.$confirm('此操作将取消修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          this.isShow = true;
          this.$message.info('已取消修改');
          this.$emit('del');
          this.prop.rfid_lase_phr = this.originalLase.rfid_lase_phr;
          this.prop.rfid_patch_lase = this.originalLase.rfid_patch_lase;
        })
        .catch(res => {});
    },
    lasePhrChange(val) {
      val = this.keepNum99(val);
      this.$emit('lasePhrChange', val);
    },
    lasePatchChange(val) {
      val = this.keepNum99(val);
      this.$emit('lasePatchChange', val);
    },
    keepNum99(val) {
      let keepTNum = Number(helper.keepTNum(val));
      if (keepTNum > 99) {
        this.$message.warning('输入范围0～99超出最大限度');
        return 99;
      } else {
        return keepTNum;
      }
    }
  },
  watch: {
    'prop.list'(newValue, oldValue) {
      this.$refs.subTable.tableData = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>
